module.exports = __webpack_public_path__ + "img/vector-10.d57dcf0e.svg";